import { API } from 'src/API'
import { create } from 'zustand'
import axios from 'src/API/config'

export const useSearchStore = create((set) => ({
  searchData: null,
  searchPagination: null,
  isLoading: false,
  detailsData: null,
  detailsPagination: null,
  onSearch: async (page) => {
    try {
      set({ isLoading: true })
      const res = await axios.get(`${API.COMMON.searchEndpoint}?page=${page}`)
      set({
        searchData: res?.data?.data || null,
        searchPagination: res?.data?.meta?.pagination || null
      })
    } catch (e) {
      console.log(e)
    } finally {
      set({ isLoading: false })
    }
  },
  onLoad: async (id) => {
    try {
      set({ isLoading: true })
      const res = await axios.get(`${API.COMMON.searchEndpoint}/${id}`)
      set({
        detailsData: res?.data?.data || null,
        detailsPagination: res?.data?.meta?.pagination || null
      })
    } catch (e) {
      console.log(e)
    } finally {
      set({ isLoading: false })
    }
  },
  onSearchDetails: async (id, page) => {
    try {
      set({ isLoading: true })
      const res = await axios.get(
        `${API.COMMON.searchEndpoint}/${id}?page=${page}`
      )
      set({
        detailsData: res?.data?.data || null,
        detailsPagination: res?.data?.meta?.pagination || null
      })
    } catch (e) {
      console.log(e)
    } finally {
      set({ isLoading: false })
    }
  }
}))

export const useAnnoncestore = create((set) => ({
  searchData: null,
  searchPagination: null,
  isLoading: false,
  detailsData: null,
  detailsPagination: null,
  onSearch: async (page, orderBy, sortDirection, superDeal, search) => {
    try {
      set({ isLoading: true })

      const isSuperDealSort = superDeal === 'active' || superDeal === 'disabled'

      let searchParams = ''

      if (isSuperDealSort) {
        searchParams = `&search=${
          superDeal === 'active' ? 'super_deal:1' : 'super_deal:0'
        }`
      }

      if (search) {
        if (searchParams === '') {
          searchParams = `&search=title:${encodeURIComponent(search)};description:${encodeURIComponent(search)}`
        } else {
          searchParams = `${searchParams};title:${encodeURIComponent(search)};description:${encodeURIComponent(search)}`
        }
      }

      const res = await axios.get(
        `${API.COMMON.annoncesEndpoint}?page=${page}${
          orderBy ? `&orderBy=${orderBy}` : ''
        }${sortDirection ? `&sortedBy=${sortDirection}` : ''}${
          searchParams ? searchParams : ''
        }&searchJoin=or`
      )
      set({
        searchData: res?.data?.data || null,
        searchPagination: res?.data?.meta?.pagination || null
      })
    } catch (e) {
      console.log(e)
    } finally {
      set({ isLoading: false })
    }
  },
  onLoad: async (id) => {
    try {
      set({ isLoading: true })
      const res = await axios.get(`${API.COMMON.annoncesEndpoint}/${id}`)
      set({
        detailsData: res?.data?.data || null,
        detailsPagination: res?.data?.meta?.pagination || null
      })
    } catch (e) {
      console.log(e)
    } finally {
      set({ isLoading: false })
    }
  },
  onSearchDetails: async (id, page) => {
    try {
      set({ isLoading: true })
      const res = await axios.get(
        `${API.COMMON.annoncesEndpoint}/${id}?page=${page}`
      )
      set({
        detailsData: res?.data?.data || null,
        detailsPagination: res?.data?.meta?.pagination || null
      })
    } catch (e) {
      console.log(e)
    } finally {
      set({ isLoading: false })
    }
  }
}))

export const useUserstore = create((set) => ({
  searchData: null,
  searchPagination: null,
  isLoading: false,
  detailsData: null,
  detailsPagination: null,
  onSearch: async (page, orderBy, sortDirection, search) => {
    try {
      set({ isLoading: true })
      const res = await axios.get(
        `${API.COMMON.usersEndpoint}?page=${page}${
          orderBy ? `&orderBy=${orderBy}` : ''
        }${sortDirection ? `&sortedBy=${sortDirection}` : ''}${
          search
            ? `&search=${`email:${encodeURIComponent(search)}`};${`name:${encodeURIComponent(search)}`}`
            : ''
        }&searchJoin=or`
      )
      set({
        searchData: res?.data?.data || null,
        searchPagination: res?.data?.meta?.pagination || null
      })
    } catch (e) {
      console.log(e)
    } finally {
      set({ isLoading: false })
    }
  },
  onLoad: async (id) => {
    try {
      set({ isLoading: true })
      const res = await axios.get(`${API.COMMON.usersEndpoint}/${id}`)
      set({
        detailsData: res?.data?.data || null,
        detailsPagination: res?.data?.meta?.pagination || null
      })
    } catch (e) {
      console.log(e)
    } finally {
      set({ isLoading: false })
    }
  },
  onSearchDetails: async (id, page) => {
    try {
      set({ isLoading: true })
      const res = await axios.get(
        `${API.COMMON.usersEndpoint}/${id}?page=${page}`
      )
      set({
        detailsData: res?.data?.data || null,
        detailsPagination: res?.data?.meta?.pagination || null
      })
    } catch (e) {
      console.log(e)
    } finally {
      set({ isLoading: false })
    }
  }
}))
